const _debounce = function (func, delay) {
    let timeoutId;
    return async function (...args) {
        clearTimeout(timeoutId);
        return new Promise((resolve) => {
            timeoutId = setTimeout(async () => {
                //@ts-ignore
                await func.apply(this, args);
                //@ts-ignore
                resolve();
            }, delay);
        });
    };
};
const Debouncer = {
    install(app, options = {}) {
        app.provide("$debouncer", (func, timeout) => {
            return _debounce(func, timeout);
        });
    }
};
export default Debouncer;
